import { connect } from 'react-redux';
import UserComponent from './user.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserComponent);



// WEBPACK FOOTER //
// ./src/components/account/user/user.ts